import {Icon, IconNames} from '@wandb/weave/components/Icon';
import React, {useCallback} from 'react';
import {twMerge} from 'tailwind-merge';

import {MaskControl} from '../MediaCard';
import {MaskVisibilityToggle} from './MaskVisibilityToggle';

type MaskHeaderProps = {
  mediaKey: string;
  maskKey: string;
  title: string;
  isImageShownForMask?: (mediaKey: string, maskKey: string) => boolean;
  toggleImageForMask?: (mediaKey: string, maskKey: string) => void;
  canShowImage?: boolean;
  hasClasses?: boolean;
  isExpanded?: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
  onToggleVisibility: () => void;
  getMaskControl: (configPath: Array<string>) => MaskControl | undefined;
};

export const MaskHeader = ({
  mediaKey,
  maskKey,
  title,
  canShowImage = true,
  hasClasses = true,
  isExpanded,
  isImageShownForMask,
  toggleImageForMask,
  setIsExpanded,
  onToggleVisibility,
  getMaskControl,
}: MaskHeaderProps) => {
  const configPath = ['toggles', mediaKey, maskKey, 'all'];
  const maskControl = getMaskControl(configPath);
  const isImageShown =
    isImageShownForMask && isImageShownForMask(mediaKey, maskKey);
  const toggleImageForMaskHandler = useCallback(() => {
    if (toggleImageForMask) {
      toggleImageForMask(mediaKey, maskKey);
    }
  }, [toggleImageForMask, mediaKey, maskKey]);
  const toggleExpanded = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded, setIsExpanded]);

  return (
    <div className={twMerge('flex w-full flex-row gap-4 px-4 py-4')}>
      <MaskVisibilityToggle
        title={`${title} masks`}
        className="flex-1"
        disabled={maskControl?.disabled ?? false}
        onToggleVisibility={onToggleVisibility}>
        <h3 className="flex flex-row items-start gap-4 text-sm font-semibold">
          {title}
          {hasClasses && (
            <Icon
              className="flex-1"
              name={isExpanded ? IconNames.ChevronNext : IconNames.ChevronDown}
              variant="ghost"
              onClick={toggleExpanded}
            />
          )}
        </h3>
      </MaskVisibilityToggle>

      {canShowImage && toggleImageForMask && (
        <MaskVisibilityToggle
          title={`${title} images`}
          className="flex-none"
          disabled={!isImageShown}
          onToggleVisibility={toggleImageForMaskHandler}>
          <p className="text-sm font-semibold leading-[24px]">Images</p>
        </MaskVisibilityToggle>
      )}
    </div>
  );
};
